export default "__VITE_ASSET__41f5e426__"